var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuInside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.335 50.55c0 1.65 1.35 3 3 3h49.33c1.65 0 3-1.35 3-3V21.896H4.335zm17.33-4.56v-1.06a2 2 0 0 1 2-2h16.67a2 2 0 0 1 2 2v1.06c0 1.1-.9 2-2 2h-16.67c-1.1 0-2-.9-2-2zm19.98-7.81h-19.29c-.55 0-1-.45-1-1s.45-1 1-1h1.25c.42-4.34 3.51-7.81 7.4-8.32v-1.15c0-.56.44-1 1-1 .55 0 1 .44 1 1v1.15c3.89.51 6.97 3.98 7.39 8.32h1.25c.55 0 1 .45 1 1s-.45 1-1 1zM56.665 10.45H7.335c-1.65 0-3 1.35-3 3v6.445h2v.005h51.33v-.005h2V13.45c0-1.65-1.35-3-3-3zm-14.77 8.09a2.364 2.364 0 0 1 0-4.73 2.364 2.364 0 0 1 0 4.73zm5.77 0a2.364 2.364 0 0 1 0-4.73c1.3 0 2.36 1.06 2.36 2.36a2.36 2.36 0 0 1-2.36 2.37zm5.77 0a2.364 2.364 0 0 1 0-4.73c1.3 0 2.36 1.06 2.36 2.36a2.36 2.36 0 0 1-2.36 2.37z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuInside);
export default __webpack_public_path__ + "static/media/MenuInside.842b5d7d28bafaa7685c78f522d3d810.svg";
export { ForwardRef as ReactComponent };